<template>
  <div id="home">
    <CommonHeader></CommonHeader>
    <div id="banner">
      <img :src="'/images/banner'+2+'.png'" />
    </div>
    <div class="main1 wrap">
      <div v-for="(item, index) in main1.header" :key="index" :class="'main1-title'+index">
        <span v-text="item.title"></span>
      </div>
      <ul class="main1-ul clearfix">
        <li v-for="(item, index) in main1.body" :key="index">
          <h3 class="main1-ul-li-title" v-text="item.title"></h3>
          <p class="main1-ul-li-content" v-text="item.content"></p>
        </li>
      </ul>
    </div>
    <div class="main2">
      <div v-for="(item, index) in main2.header" :key="index" :class="'main2-title'+index">
        <span v-text="item.title"></span>
      </div>
      <ul class="wrap main2-ul">
        <li v-for="(item, index) in main2.body" :key="index">
          <h3 class="main2-ul-li-title" v-text="item.title"></h3>
          <p class="main2-ul-li-content" v-text="item.content"></p>
        </li>
      </ul>
    </div>
    <div class="mian3 wrap">
      <div><span class="arrow"></span></div>
      <div class="main3-body clearfix">
        <div class="main3-body-left"  v-for="(item, index) in main3.body" :key="index">
          <h3>
            <span>1</span>
            <strong v-text="item.title"></strong>
          </h3>
          <p v-text="item.content"></p>
        </div>
        <div class="main3-body-right">
          <img src="/images/img-main3.png" />
        </div>
      </div>
      <a class="mian3-btn" href="https://wide.ksbao.com/html/start.html" target="_blank" v-text="main3.btn"></a>
    </div>
    <div class="main5">
      <div v-for="(item, index) in main5.header" :key="index" :class="'main5-title'+index">
        <span v-text="item.title"></span>
      </div>
      <ul class="wrap main5-ul">
        <li v-for="(item, index) in main5.body" :key="index">
          <div class="icon"><img :src="'/images/img-m5-'+ index +'.png'" /></div>
          <h3 class="main5-ul-li-title" v-text="item.title"></h3>
          <p class="main5-ul-li-content" v-text="item.content"></p>
        </li>
      </ul>
    </div>
    <CommonFooter></CommonFooter>
  </div>
</template>

<script>
// @ is an alias to /src
import CommonHeader from "@/components/CommonHeader.vue"
import banner from "@/components/banner.vue"
import CommonFooter from "@/components/CommonFooter.vue"

export default {
  name: "home",
  components: {
    CommonHeader,
    banner,
    CommonFooter
  },

  data() {
    return {
      main1: {
        header: [],
        body: [],
      },
      main2: {
        header: [],
        body: [],
      },
      main3: {
        //header: [],
        body: [],
        btn: '',
      },
      main5: {
        header: [],
        body: [],
      },
    }
  },

  created() {
    this.loadData();
  },

  methods: {
    loadData() {
      this.$http
        .get("/data/home.json")
        .then((response) => {
          if (response.data) {
            this.main1.header = response.data.main1.header;
            this.main1.body = response.data.main1.body;

            this.main2.header = response.data.main2.header;
            this.main2.body = response.data.main2.body;

            //this.main3.header = response.data.main3.header;
            this.main3.body = response.data.main3.body;
            this.main3.btn = response.data.main3.btn;

            this.main5.header = response.data.main5.header;
            this.main5.body = response.data.main5.body;
          }
        })
        .catch(err => {
          console.log(err);
        })
    }
  }
};
</script>

<style lang="less">
.main1 {
  height: 403px;
  padding: 49px 0 58px;
  text-align: center;

  .main1-title0 {
    font-size: 24px;
    font-weight: bold;
    font-family: MicrosoftYaHei-Bold;
    color: #2c89d8;

    span {
      position: relative;

      &:after {
        display: block;
        content: "";
        position: absolute;
        left: 38%;
        bottom: -15px;
        width: 28px;
        height: 2px;
        background: #2c89d8;

      }
    }
  }

  .main1-title1 {
    padding: 26px 0 69px;
    font-size: 14px;
    color: #666;
  }

  .main1-ul {
    li {
      float: left;
      width: 260px;
      height: 156px;
      margin-left: 228px;
      padding: 0 24px;
      box-shadow: 0px 8px 15px 0px rgba(189,189,189,0.25);
      opacity: 0.85;
      overflow: hidden;

      &:hover {
        cursor: pointer;
        opacity: 1;
      }

      &:nth-child(1) {
        //margin-left: 60px;
        background: url('/images/img-m1-1.png') center no-repeat;
        background-size: cover;
      }

      &:nth-child(2) {
        background: url('/images/img-m1-2.png') center no-repeat;
        background-size: cover;
      }

      &:nth-child(3) {
        background: url('/images/img-m1-3.png') center no-repeat;
        background-size: cover;
      }

      &:not(:first-child) {
        //margin-left: 150px;
      }

      .main1-ul-li-title {
        padding: 19px 0;
        font-size: 18px;
        font-weight: bold;
        color: #fff;
      }

      .main1-ul-li-content {
        line-height: 2;
        font-size: 14px;
        color: #fff;
      }
    }
  }
}

.main2 {
  min-width: 1200px;
  height: 442px;
  background: url('/images/bg-main2.png') center no-repeat;
  background-size: cover;

  .main2-title0 {
    padding: 59px 0 15px;
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    color: #fff;

      span {
        position: relative;

        &:after {
          display: block;
          content: "";
          position: absolute;
          left: 38%;
          bottom: -15px;
          width: 28px;
          height: 2px;
          background: #fff;

        }
      }
  }

  .main2-ul {
    padding: 20px 0 0 200px;

    li {
      overflow: hidden;
    }

    .main2-ul-li-title {
      padding: 61px 0 11px;
      font-size: 26px;
      font-weight: bold;
      color: #fff;
    }

    .main2-ul-li-content {
      font-size: 14px;
      color: #fff;
    }
  }
}

.mian3 {
  height: 600px;

  .arrow {
    position: relative;
    bottom: -16px;
    left: 585px;
    border-top: solid 16px #8596f4;
    border-right: solid 15px transparent;
    border-bottom: solid 16px transparent;
    border-left: solid 15px transparent;
  }

  .main3-body {
    padding: 58px 0 0;

    .main3-body-left {
      float: left;
      width: 409px;
      padding-top: 120px;
      overflow: hidden;

      h3 {
        padding-bottom: 20px;

        span {
          display: inline-block;
          width: 55px;
          height: 55px;
          margin-right: 13px;
          line-height: 55px;
          text-align: center;
          border: solid 3px #adadad;
          font-size: 30px;
          color: #aeadad;
          vertical-align: middle;
        }

        strong {
          display: inline-block;
          height: 55px;
          line-height: 55px;
          font-size: 24px;
          color: #444;
        }
      }

      p {
        font-size: 16px;
        line-height: 29px;
        color: #666;
      }
    }

    .main3-body-right {
      float: left;
      width: 600px;
      margin-left: 94px;

      img {
        max-width: 100%;
        height: auto;
      }
    }
  }

  .mian3-btn {
    display: block;
    width: 134px;
    height: 40px;
    line-height: 40px;
    margin: 74px auto 0;
    border-radius: 20px;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    color: #fff;
    background: #ff9e40;

    &:hover {
      background: #b07f22;
    }
  }
}

.main5 {
  height: 495px;
  min-width: 100%;
  background: url("/images/bg-main5.png") center no-repeat;
  background-size: cover;

  .main5-title0 {
    padding: 60px 0 15px;
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    color: #fff;

      span {
        position: relative;

        &:after {
          display: block;
          content: "";
          position: absolute;
          left: 38%;
          bottom: -15px;
          width: 28px;
          height: 2px;
          background: #fff;

        }
      }
  }

  .main5-ul {
    padding-top: 60px;

    li {
      float: left;
      width: 378px;
      height: 247px;
      padding: 38px;
      margin-left: 148px;
      background: #fff;
      box-shadow: 0px 6px 10px 0px rgba(235, 236, 237, 1);
      border-radius: 6px;

      &:not(:first-child) {
        //margin-left: 33px;
      }

      .main5-ul-li-title {
        padding: 34px 0 23px;
        font-size: 16px;
        font-weight: bold;
        color: #333;
      }

      .main5-ul-li-content {
        font-size: 14px;
        height: 24px;
        color: #999;
      }
    }
  }
}
</style>
